module.exports = __webpack_public_path__ + "static/media/DK.694bde89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/DK.svg
// module id = 239
// module chunks = 0